import { render, staticRenderFns } from "./tabSubBillUICustom.vue?vue&type=template&id=8988b306&"
import script from "./tabSubBillUICustom.vue?vue&type=script&lang=js&"
export * from "./tabSubBillUICustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8988b306')) {
      api.createRecord('8988b306', component.options)
    } else {
      api.reload('8988b306', component.options)
    }
    module.hot.accept("./tabSubBillUICustom.vue?vue&type=template&id=8988b306&", function () {
      api.rerender('8988b306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBillUICustom.vue"
export default component.exports